import React from "react";
import BlogPage from '../../../components/BlogPage';
import { Seo } from "../../../components/Seo";
import { blogHundredSix } from "../../../constants/blogData/blogHundredSix";

const BlogPageblogHundredSix = () => {
  return (
    <BlogPage data={blogHundredSix} />
  );
};

export default BlogPageblogHundredSix;

export const Head = () => (
<Seo
  title="Best Vegan & Vegetarian Restaurants in San Francisco - 2025"
  description="Discover the top vegan and vegetarian dining spots in San Francisco for 2025. Explore unique plant-based dishes at the best restaurants in the city."
  canonicalHref="https://foodaholix.com/blogs/best-vegan-vegetarian-restaurants-san-francisco-2025"
/>
)
